var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconLockFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0c-3.854 0-7 3.146-7 7v2h-2a2 2 0 00-2 2v12a2 2 0 002 2h18a2 2 0 002-2V11a2 2 0 00-2-2h-2V7c0-3.728-2.963-6.731-6.645-6.928A1 1 0 0012.5 0zm0 2c2.774 0 5 2.226 5 5v2h-10V7c0-2.774 2.226-5 5-5z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonIconLockFilled;